import { Link, Route } from "react-router-dom/cjs/react-router-dom.min";
import RecruitMain from "./RecruitMain";
import RecruitJobPosition from "./RecruitJobPosition";
import CompRecruit from "./CompRecruit";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

function Recruit({ match }) {
  const btnBox = document.getElementsByClassName("basic-item")[0];
  const [box, setBox] = useState(); // eslint-disable-line no-unused-vars
  const [link, setLink] = useState(window.location.href);

  const getLink = () => {
    setLink(window.location.href);
  };

  useEffect(() => {
    getLink();
    setBox(document.getElementsByClassName("basic-item")[0]);
  }, [btnBox]);

  //링크에 따른 클래스 부여
  if (link?.includes("overview")) {
    classRemove(btnBox?.children);
    btnBox?.children[0].classList.add("on");
  } else if (link?.includes("jobposition")) {
    classRemove(btnBox?.children);
    btnBox?.children[1].classList.add("on");
  }

  //버튼 클릭시 이동(임시)
  const onMovePage = (e) => {
    const targetValue = e.target;

    classRemove(btnBox?.children);
    targetValue.parentNode.classList.add("on");
  };

  //on 클래스 삭제
  function classRemove(arr) {
    for (let i = 0; i < arr?.length; i++) {
      arr[i].classList.remove("on");
    }
  }

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <>
      <div className="basic-main">
        <div className="basic-visual recruit-visual">
          <div className="inner">
            <h2 className="basic-visual-title">인재 채용</h2>
            <div className="basic-visual-cont">
              {pc ? (
                <>
                  <p>배려와 공감 속에서 창의와 자율을 통해 능력을 개발하며</p>
                  <p>동반 성장하는 문화를 가진 기업</p>
                </>
              ) : (
                <>
                  <p>
                    배려와 공감 속에서 창의와 자율을 통해 능력을 개발하며 동반
                    성장하는 문화를 가진 기업
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="basic-tap">
          <ul className="basic-item" onClick={onMovePage}>
            <li className="basic-list">
              <Link to="/recruit/overview" className="basic-link">
                인재 채용
              </Link>
              <span className="line"></span>
            </li>
            <li className="basic-list">
              <Link to="/recruit/jobposition" className="basic-link">
                채용 공고
              </Link>
              <span className="line"></span>
            </li>
          </ul>
        </div>
      </div>
      <div className="basic-inner">
        <Route
          path={`${match.path}/overview`}
          exact={true}
          render={() => <RecruitMain getLink={getLink} />}
        />
        <Route
          path={`${match.path}/jobposition`}
          exact={true}
          render={() => <RecruitJobPosition getLink={getLink} />}
        />
        <Route
          path={`${match.path}/jobposition/:id`}
          component={CompRecruit}
          getLink={getLink}
        />
      </div>
    </>
  );
}

export default Recruit;
